import { render } from "./PageTitle.vue?vue&type=template&id=d1f3a6ee&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=d1f3a6ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d1f3a6ee"

export default script